import axios from "axios";
import { baseUrlAutoClosingOfferGcp } from "../../config/api/apiConfig";

class OfferGcpApiService {
    private axios = axios.create({
        baseURL: baseUrlAutoClosingOfferGcp,
        timeout: 9000000,
    });

    public async autoClosing(inputData?: any) {
        try {
            return await this.axios.post<any>('/auto-closing',
                inputData, {
                // timeout: 100000000000,
                headers: {
                    "Content-Type": "application/json",
                    "X-Api-Key": "none"
                }
            });
        } catch (e: any) {
            throw new Error(e.response.data.error.message);
        }
    }

    public async preRunner(companyCode?: string) {
        try {
            return await this.axios.get<any>(`/pre-runner/${companyCode}`, {
                headers: {
                    "X-Api-Key": "none",
                },
            });
        } catch (e: any) {
            throw new Error(e.response.data.error.message);
        }
    }
}

export const offerGcpApiService = new OfferGcpApiService();
